import { ReactElement, useContext, useMemo } from 'react';
import LayoutContext from '../../../contexts/LayoutContext';
import logotipo from '../../../assets/images/logotipo.jpg';
import HeaderBreadcrumb from './HeaderBreadcrumb';
import BuscadorRapido from './BuscadorRapido';
import AuthContext from '../../../contexts/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';
import getMenuBarItems from '../../../utils/menubar';
import { getPantallaActual, getPantallas } from '../../../utils/menuGroups';
import { FavoritoStar } from '../menuBar/MenuBarItem';

const Header = (): ReactElement => {
    const { headerTitle, toggleMenuBar } = useContext(LayoutContext);
    const { userName, userRut, userRoles, logout } = useContext(AuthContext);
    const history = useHistory();
    const { pathname } = useLocation();
    // Estrella de la página actual, solo si es una pantalla del menú visible para el usuario.
    const pantallaActual = useMemo(
        () => getPantallaActual(getPantallas(getMenuBarItems(userRoles)), pathname),
        [userRoles, pathname]
    );

    const changeMenuBarState = (): void => toggleMenuBar();

    const userProfile = (): void => {
        toggleMenuBar(false)
        history.push(`/users/currentUser/${userRut}`);
    }

    const isCliente = (): boolean => {
        return userRoles.includes('CLIENTE');
    }

    return (
        <div>
            <div className = "header">
                <img className = "header-logo" src = {logotipo} alt = "Logo Electrans"/>
                <div className = "header-title">{headerTitle}</div>
                <div className = "header-user-card">
                    <div className = "header-text-user-card">
                        {userName}
                    </div>
                    {!isCliente() && (<button
                        className = "btn header-button-user-card"
                        type = "button"
                        onClick = {userProfile}
                    >
                        <i className="fa fa-user fa-lg"></i>
                    </button>)}
                    <button
                        className = "btn header-button-user-card"
                        type = "button"
                        onClick = {logout}
                    >
                        <i className="fa fa-sign-out fa-lg"></i>   
                    </button>
                </div>
            </div>
            <div className = "sub-header">
                <button
                    className="btn menu-button d-md-none"
                    type="button"
                    onClick={changeMenuBarState}
                    disabled = {isCliente()}
                    aria-label="Abrir menú"
                >
                    <i className="fa fa-bars fa-lg"></i>
                </button>
                <HeaderBreadcrumb />
                {!isCliente() && pantallaActual && (
                    <div className="header-favorito">
                        <FavoritoStar href={pantallaActual.href} name={pantallaActual.name} />
                    </div>
                )}
                {!isCliente() && <BuscadorRapido />}
            </div>
        </div>
    )
}

export default Header;